'use client';
import { CheckmarkIcon } from '@curology/ui-components-web/react/Icon/icons/CheckmarkIcon';
import { Link } from '@curology/ui-components-web/react/Link';
import { Typography } from '@curology/ui-components-web/react/Typography';
import { useAtom } from 'jotai';
import React from 'react';

import { FlashMessagesState } from '@/atoms/flashMessages/flashMessagesState';
import { type Brand } from '@/consts/brands';
import { PhoneNumberVerificationService } from '@/services/phoneNumberVerificationService/client';
import { AnalyticsEvent, trackEvent } from '@/utils/analytics';

const SmsLink = ({
  brand,
  setPhoneNumber,
  setShowVerifyPhoneNumberModal,
}: {
  brand: Brand;
  setPhoneNumber: React.Dispatch<React.SetStateAction<string>>;
  setShowVerifyPhoneNumberModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [flashMessages, setFlashMessages] = useAtom(
    FlashMessagesState.flashMessagesAtom,
  );

  return (
    <Typography className="cur-my-4">
      Want to use your phone?{' '}
      <Link
        className="cur-font-bold"
        href=""
        onClick={async (event) => {
          event.preventDefault();

          const phoneNumberObject =
            await PhoneNumberVerificationService.getPhoneNumberObject(brand);

          if (phoneNumberObject.confirmedAt) {
            await PhoneNumberVerificationService.postSmsSendMessage(brand);

            setFlashMessages([
              ...flashMessages,
              {
                children: 'We just texted you a link to upload your photos.',
                icon: <CheckmarkIcon />,
                iconSize: 'sm',
                state: 'success',
                title: 'Great!',
              },
            ]);

            trackEvent(AnalyticsEvent.PHOTO_UPLOAD_SMS_LINK_SENT);
          } else {
            setPhoneNumber(phoneNumberObject.number);
            setShowVerifyPhoneNumberModal(true);
          }
        }}
      >
        We’ll text you a link
      </Link>
    </Typography>
  );
};

export default SmsLink;
